const RECOVERY_KEY = 'gwAuthRecovery';
const ENROLLMENT_KEY = 'gwEnrollmentRedirect';
const TTL_MS = 10 * 60 * 1000; // 10 minutes — tab-scoped, clears on tab close

function isRecoveryAttempted() {
    try {
        const raw = sessionStorage.getItem(RECOVERY_KEY);
        if (!raw) return false;
        const { timestamp } = JSON.parse(raw);
        return Date.now() - timestamp < TTL_MS;
    } catch {
        return false;
    }
}

function markRecoveryAttempted() {
    sessionStorage.setItem(RECOVERY_KEY, JSON.stringify({ timestamp: Date.now() }));
}

function clearRecoveryMarker() {
    sessionStorage.removeItem(RECOVERY_KEY);
    sessionStorage.removeItem(ENROLLMENT_KEY);
}

function isEnrollmentRedirect() {
    return sessionStorage.getItem(ENROLLMENT_KEY) === 'true';
}

function clearOktaStorage() {
    try {
        const localKeysToRemove = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && (key.startsWith('okta-') || key.includes('okta'))) {
                localKeysToRemove.push(key);
            }
        }
        localKeysToRemove.forEach(key => localStorage.removeItem(key));

        const sessionKeysToRemove = [];
        for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i);
            if (key && key !== RECOVERY_KEY && key !== ENROLLMENT_KEY
                && (key.startsWith('okta-') || key.includes('okta'))) {
                sessionKeysToRemove.push(key);
            }
        }
        sessionKeysToRemove.forEach(key => sessionStorage.removeItem(key));
    } catch (e) {
        // Best effort
    }
}

export default { isRecoveryAttempted, markRecoveryAttempted, clearRecoveryMarker, isEnrollmentRedirect, clearOktaStorage };
